import React from 'react';
import { Flex, Link, Text } from '@chakra-ui/react';

const Footer = () => (
  <Flex bgColor="gray.100" pos="fixed" bottom="0" w="100%" p="2">
    <Text fontSize="sm">
      Powered by
      {' '}
      <Link href="https://vulcan.observer/" isExternal fontWeight="bold">Vulcan Observer</Link>
    </Text>
  </Flex>
);

export default Footer;
